<div class="screen screen--split">

  <app-theme-header></app-theme-header>

  <h1 class="screen__title">Please Confirm<br />Your Order</h1>

  <div class="screen__stage">
    <div class="panel receipt">

      <div class="receipt__row receipt__row--head">
        <span>UNIT</span>
        <span>PRICE</span>
      </div>

      <hr class="hairline" />

      <div class="receipt__row">
        <span class="receipt__label">{{ host.TXT_PAYMENT_PRICE_PRODUCT_NAME }}</span>
        <span class="receipt__value">
          <s *ngIf="host.isGotDiscount">{{ host.fullPrice | number: ".2" }} {{ host.TXT_PAYMENT_PRICE_LABEL_CURRENCY }}</s>
          <ng-container *ngIf="!host.isGotDiscount">{{ host.fullPrice | number: ".2" }} {{ host.TXT_PAYMENT_PRICE_LABEL_CURRENCY }}</ng-container>
        </span>
      </div>

      <div class="receipt__row" *ngIf="host.isGotDiscount">
        <span class="receipt__label">{{ host.TXT_PAYMENT_PRICE_LABEL_DISCOUNT }}</span>
        <span class="receipt__value">-{{ host.discountPrice | number: ".2" }} {{ host.TXT_PAYMENT_PRICE_LABEL_CURRENCY }}</span>
      </div>

      <div class="receipt__row" *ngIf="host.isGotDiscount">
        <span class="receipt__label"></span>
        <span class="receipt__value">{{ host.deductedPrice | number: ".2" }} {{ host.TXT_PAYMENT_PRICE_LABEL_CURRENCY }}</span>
      </div>

      <div class="receipt__row" [hidden]="host.vatPrice === 0">
        <span class="receipt__label">{{ host.TXT_PAYMENT_PRICE_LABEL_VAT }} {{ host.vatPercent }}%</span>
        <span class="receipt__value">{{ host.vatPrice | number: ".2" }} {{ host.TXT_PAYMENT_PRICE_LABEL_CURRENCY }}</span>
      </div>

      <hr class="hairline" />

      <div class="receipt__row receipt__row--total">
        <span class="receipt__label">{{ host.TXT_PAYMENT_PRICE_LABEL_NET }}</span>
        <span class="amount-box">{{ host.totalPrice | number: ".2" }} {{ host.TXT_PAYMENT_PRICE_LABEL_CURRENCY }}</span>
      </div>

    </div>

    <button type="button" class="outline-button outline-button--primary" (click)="host.onCheckout()"
      [disabled]="host.commonService.isLoading" [hidden]="host.isGettingPrice">
      CONFIRM
    </button>
  </div>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.onBack()">BACK</button>
  </div>

</div>
